import React, { useContext, useEffect, useState } from "react";
import {CURRENT_INST} from "@/constants/token.const";
import {useAuth} from "@/context/AuthContext";

const InstContext = React.createContext();

export function useInst() {
    return useContext(InstContext);
}

export function InstProvider({ children }) {
    const [currentInst, setCurrentInst] = useState(null);
    const {auth} = useAuth();

    function setInst(instid) {
        sessionStorage.setItem(CURRENT_INST, instid);
        setCurrentInst(instid);
    }

    useEffect(() => {
        if(auth.user) {
            setCurrentInst(parseInt(sessionStorage.getItem(CURRENT_INST) ?? auth.user.instid));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const value = {
        currentInst,
        setInst
    };

    return <InstContext.Provider value={value}>{children}</InstContext.Provider>;
}

export default InstContext;
